import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Tabs from "../tabs.component"

class ProductTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }

    render() {

        let productTabs = [
            {
                name: <FormattedMessage
                    id="menu.tabs.products.products_and_services"
                    defaultMessage="Products and services"
                />,
                link: '/products/catalog',
            }]

            productTabs = [...productTabs, {

                name: <FormattedMessage
                    id="menu.tabs.products.bundles"
                    defaultMessage="Bundles"
                />,
                link: '/bundles',
            }]


        productTabs = [...productTabs, {
            name: <FormattedMessage
                id="menu.tabs.products.matrices"
                defaultMessage="Matrices"
            />,
            link: '/matrices/catalog',
        },
            {
                name: <FormattedMessage
                    id="menu.tabs.products.price_levels"
                    defaultMessage="Price Levels"
                />,
                link: '/priceLevels/catalog',
            },
        ]

        return (
            <Tabs value={productTabs}/>
        )
    }
}

export default ProductTabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs/products.component.jsx